<template>
  <div class="module-page">
    <div class="container pt-0 pb-0">
      <div class="module-page__top-menu">
        <div class="module-page__top-menu__nav__prev">
          <NuxtLink class="btn btn-link" type="button" href="/partners">
            <IconBack class="icon" />
            <span class="text">Back</span>
          </NuxtLink>
        </div>
        <div class="module-page__top-menu__nav">
          <div class="module-page__top-menu__nav__prev">
            <NuxtLink class="btn btn-link" type="button" :href="prevPartnerUrl">
              <IconChevronLeft class="icon" />
              <span class="text">Previous</span>
            </NuxtLink>
          </div>
          <div class="module-page__top-menu__nav__next">
            <NuxtLink class="btn btn-link" type="button" :href="nextPartnerUrl">
              <span class="text">Next</span>
              <IconChevronLeft class="icon icon-reverse" />
            </NuxtLink>
          </div>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="row">
        <div class="col-lg-6" data-aos="fade-in">
          <div class="modality">
            <SmartLinkStandaloneElement :codename="type.elements.modality.codename">
              <p>{{ modality }}</p>
            </SmartLinkStandaloneElement>
          </div>
          <div class="title">
            <SmartLinkStandaloneElement :codename="type.elements.module_title.codename">
              <h2>{{ data.title }}</h2>
            </SmartLinkStandaloneElement>
          </div>
        </div>
        <div class="col-lg-6" data-aos="fade-in">
          <div class="contributors" v-if="data.contributors.length > 0">
            <div class="header">Contributors</div>
            <SmartLinkStandaloneElement :codename="type.elements.contributors.codename">
              <ul class="link-list">
                <li v-for="item in contributors">
                  <NuxtLink class="link" :to="item.link">
                    <span class="text">{{ item.elements.partner_title.value }}</span>
                    <IconArrowRightLong class="icon" />
                  </NuxtLink>
                </li>
              </ul>
            </SmartLinkStandaloneElement>
          </div>
        </div>
      </div>
    </div>

    <div class="content">
      <SmartLinkStandaloneElement :codename="type.elements.content.codename">
        <RichText v-if="!isEmpty(data.content)" :value="data.content" />
      </SmartLinkStandaloneElement>
    </div>
  </div>
    <SocialSharePreviewBlock v-if="page.elements.social_share_preview.value.length > 0" 
                                 :model="pageStore.getLinkedItem<SocialSharePreviewModel>(page.elements.social_share_preview.value[0]!)"/>
</template>

<script lang="ts" setup>
import { contentTypes, type ModuleItemModel, type SocialSharePreviewModel } from '~~/app/models'
import type { PartnerItemWithLink } from '~~/app/types/PartnerWithLink'
const type = contentTypes.module_item

const { setStateValue } = usePartnerState()

setStateValue('module')

const pageStore = usePageStore()
const modalityFilterStore = useModalityFilter()

const page = pageStore.page as ModuleItemModel
const data = {
  title: page.elements.module_title.value,
  modality: getModality(page),
  contributors: pageStore.getListAs<PartnerItemWithLink>(page.elements.contributors.value),
  content: page.elements.content.value,
  shortDescription: page.elements.short_description.value
}
const modality = computed(() => getModality(page))

function getModality(item: ModuleItemModel) {
  if (firstOrDefault(item.elements.modality.value)) {
    return item.elements.modality.value
      .map((x) => x.codename.replace('_module', '').split('_').join(' '))
      .join(', ')
  }
  return ''
}

const links = await useFetch(`/api/partners-routes`)

links.data.value?.data?.forEach((result) => {
  const item = data.contributors.find((x: any) => x.system.codename == result.codename)
  if (item) {
    item.link = result.path
  }
})

const contributors = computed(() => data.contributors)

const modules = await useFetch('/api/modules')
const modulesWithModalities = (modules.data?.value as any).data as any[]
const moduleFilter = modalityFilterStore.get()
const modulesFiltered = modulesWithModalities.filter((m) =>
  m.modalities.find((modality: any) =>
    (moduleFilter.length > 0 ? moduleFilter : [modality.codename]).includes(modality.codename)
  )
)

const modulesCodenames = modulesFiltered.map((m) => m.module)
const currentCodename = page.system.codename
const nextIndex = (modulesCodenames.indexOf(currentCodename) + 1) % modulesCodenames.length
const nextRoute =
  links.data.value?.data?.find((l) => l.codename == modulesCodenames[nextIndex])?.path ?? ''
const prevIndex =
  (modulesCodenames.indexOf(currentCodename) - 1 + modulesCodenames.length) %
  modulesCodenames.length
const prevRoute =
  links.data.value?.data?.find((l) => l.codename == modulesCodenames[prevIndex])?.path ?? ''
const nextPartnerUrl = ref(nextRoute)
const prevPartnerUrl = ref(prevRoute)
</script>
